import React from 'react';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import ContributionsList from '../contributions/ContributionsList';
import ClubExpensesList from '../club_expenses/ClubExpensesList';

const GameFinancesPage = () => {
    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Game Finances" />
                
                {/* --- ADD THIS STYLE BLOCK FOR THE TABS --- */}
                <style>
                    {`
                        #finances-tabs .nav-link.active {
                            background-color: rgb(15, 98, 106) !important;
                            color: white !important;
                            border-color: rgb(15, 98, 106) !important;
                        }
                        #finances-tabs .nav-link:not(.active) {
                            color: black !important;
                            background-color: #f0f0f0; /* A light grey for inactive tabs */
                        }
                        #finances-tabs .nav-link:not(.active):hover {
                            border-color: #dee2e6; /* Keep a subtle hover effect */
                        }
                    `}
                </style>

                <ul className="nav nav-tabs" id="finances-tabs" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="contributions-tab" data-bs-toggle="tab" data-bs-target="#contributions-panel" type="button" role="tab" aria-controls="contributions-panel" aria-selected="true">
                            Game Contributions
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link" id="expenses-tab" data-bs-toggle="tab" data-bs-target="#expenses-panel" type="button" role="tab" aria-controls="expenses-panel" aria-selected="false">
                            Club Expenses
                        </button>
                    </li>
                </ul>

                <div className="tab-content pt-0" id="finances-tabs-content">
                    {/* Note: The components inside the tabs have their own <div class="card">,
                         so we don't need an extra card wrapper here. */}
                    <div className="tab-pane fade show active" id="contributions-panel" role="tabpanel">
                        <ContributionsList />
                    </div>
                    <div className="tab-pane fade" id="expenses-panel" role="tabpanel">
                        <ClubExpensesList />
                    </div>
                </div>
            </div>
        </main>
    );
};

export default GameFinancesPage;